import { CaseWorkflowNode } from 'app/core/enums';
import { StepBarNode } from '../step-bar';

export const CASE_WORKFLOW_NODE_CONFIGS: StepBarNode[] = [
    {
        key: CaseWorkflowNode.PatientInfo,
        title: 'general.patientInfo',
    },
    {
        key: CaseWorkflowNode.TreatmentType,
        title: 'general.treatmentType',
    },
];
